import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_CREATE_RESET,
  ORDER_TRACK_REQUEST,
  ORDER_TRACK_SUCCESS,
  ORDER_TRACK_FAIL,
  WAITER_CALL_REQUEST,
  WAITER_CALL_SUCCESS,
  WAITER_CALL_FAIL,
  WAITER_CALL_RESET,
} from "../constants/orderConstants";

export const orderCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
      return {
        loading: true,
      };
    case ORDER_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        order: action.payload,
      };

    case ORDER_CREATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case ORDER_CREATE_RESET:
      return {};

    default:
      return state;
  }
};

export const orderTrackReducer = (state = { loading: true, order: null }, action) => {
  switch (action.type) {
    case ORDER_TRACK_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ORDER_TRACK_SUCCESS:
      return {
        loading: false,
        order: action.payload,
      };

    case ORDER_TRACK_FAIL:
      return {
        loading: false,
        order: state.order,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const waiterCallReducer = (state = {}, action) => {
  switch (action.type) {
    case WAITER_CALL_REQUEST:
      return {
        loading: true,
      };
    case WAITER_CALL_SUCCESS:
      return {
        loading: false,
        success: true,
        result: action.payload,
      };

    case WAITER_CALL_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case WAITER_CALL_RESET:
      return {};

    default:
      return state;
  }
};